import { useQuery } from '@tanstack/react-query';
import { listPropertyContactsHousesHouseIdContactsGetOptions } from '@/client/@tanstack/react-query.gen';

/**
 * Fetches all contacts for a specific property with summary statistics
 * including total contacts, core categories filled, and contacts grouped by category.
 */
export const usePropertyContacts = (houseId: number, enabled = true) => {
	return useQuery({
		...listPropertyContactsHousesHouseIdContactsGetOptions({
			path: { house_id: houseId },
		}),
		enabled: !!houseId && enabled,
	});
};
